<eda-dialog2 [display]="display" [header]="title" width="50vw" height="80vh"
  [disableApply]="(selectedUsers.length < 1 && selectedRoles.length < 1  && !anyoneCanSee)">

   <div content class="p-2 space-y-6">
    <div class="p-3 border-b border-gray-200">
      @if (!anyoneCanSee) {
        <p class="text-lg text-gray-600 leading-relaxed" i18n="@@anyCanSeeNoTable">
          Define quién puede acceder y ver esta tabla. Solo los usuarios y grupos explícitamente autorizados tendrán
          acceso.
        </p>
      } @else {
        <p class="text-lg text-gray-600 leading-relaxed" i18n="@@anyCanSeeYesTable">
          Cualquier usuario puede ver la tabla.
          Los filtros de seguridad se definen a nivel de tabla y columna concreta.
        </p>
      }
    </div>

    <!-- Access Restriction Toggle -->
    <div class="bg-gray-50 rounded-lg border border-gray-200">
      <div class="p-3">
        <div class="flex items-center justify-between">
          <div class="space-y-1">
            @if(permission) {
              <h3 class="text-lg font-medium text-gray-900" i18n="@@tableRestrictionAccess">Los usuarios y grupos configurados tendrán acceso autorizado a la tabla: <span class="font-bold">{{table.description}}</span></h3>
              <p class="text-base text-gray-600" i18n="@@ModelRestrictionAccessMessageOption">Desactivar para habilitar el acceso a todos los usuarios</p>
            } @else {
              <h3 class="text-lg font-medium text-gray-900" i18n="@@tableActivationAccess">Los usuarios y grupos configurados NO tendrán acceso a la tabla: <span class="font-bold">{{table.description}}</span></h3>
              <p class="text-base text-gray-600" i18n="@@tableActivationAccessMessageOption">Activar para habilitar un acceso restringido</p>
            }
          </div>

          <button 
            type="button" 
            role="switch" 
            [attr.aria-checked]="!permission"
            (click)="permission = !permission"
            class="peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50" 
            [ngClass]="{'bg-[var(--corporate-primary)]': permission, 'bg-input': !permission}"
          >
            <span 
              class="pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform" 
              [ngClass]="{'translate-x-5': permission, 'translate-x-0': !permission}"
            ></span>
          </button>
          
        </div>
      </div>
    </div>

    @if (!anyoneCanSee) {
      <!-- Permission Type Selection -->
      <div class="bg-gray-50 rounded-lg border border-gray-200">
        <div class="p-3 border-b border-gray-200">
          <h3 class="text-xl font-medium text-gray-900" i18n="@@permissionType">Tipo de Permisos</h3>
          <p class="text-base text-gray-600" i18n="@@permissionTypeDescription">Selecciona cómo quieres gestionar los permisos</p>
        </div>
        <div class="p-3 space-y-4">
          <!-- User Permissions Radio -->
          <div
            class="perm-row flex items-center space-x-3 p-3 rounded-lg border bg-white border-gray-200 transition-colors cursor-pointer"
            (click)="setPermissionType('users')">
            <input type="radio" id="user-permissions" name="permissionType" value="users"
              [checked]="type === 'users'"
              class="perm-radio w-4 h-4 bg-gray-100 border-gray-300">
            <label for="user-permissions" class="flex items-center gap-2 cursor-pointer flex-1">
              <svg class="h-4 w-4 text-[var(--corporate-primary)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
              <div>
                <div class="text-base font-medium text-gray-900" i18n="@@permissionTypeUser">Permisos por Usuario</div>
                <div class="text-sm text-gray-600" i18n="@@permissionTypeUserDescription">Asignar permisos individualmente a usuarios específicos</div>
              </div>
            </label>
          </div>

          <!-- Group Permissions Radio -->
          <div
            class="perm-row flex items-center space-x-3 p-3 rounded-lg border bg-white border-gray-200 transition-colors cursor-pointer"
            (click)="setPermissionType('groups')">
            <input type="radio" id="group-permissions" name="permissionType" value="groups"
              [checked]="type === 'groups'"
              class="perm-radio w-4 h-4 bg-gray-100 border-gray-300">
            <label for="group-permissions" class="flex items-center gap-2 cursor-pointer flex-1">
              <svg class="h-4 w-4 text-[var(--corporate-primary)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z">
                </path>
              </svg>
              <div>
                <div class="text-base font-medium text-gray-900" i18n="@@permissionTypeGroup">Permisos por Grupo</div>
                <div class="text-sm text-gray-600" i18n="@@permissionTypeGroupDescription">Asignar permisos a grupos de usuarios</div>
              </div>
            </label>
          </div>

          <!-- User Selection -->
          @if(type === 'users'){
            <div class="space-y-3 mt-4">
              <label class="text-base font-medium text-gray-900" i18n="@@selectUsers">Seleccionar Usuarios</label>
              <p-multiSelect
                [(ngModel)]="selectedUsers"
                [options]="users"
                [style]="{ width: '100%' }"
                [itemSize]="30"
                [virtualScroll]="true"
                [maxSelectedLabels]="3"
                [defaultLabel]="usersDefaultLabel"
                appendTo="body">
              </p-multiSelect>
            </div>
          } 

          <!-- Group Selection -->
          @if(type === 'groups'){
            <div class="space-y-3 mt-4">
              <label class="text-base font-medium text-gray-900" i18n="@@selectGroups">Seleccionar Grupos</label>
              <p-multiSelect
                [(ngModel)]="selectedRoles"
                [options]="roles"
                [itemSize]="30"
                [virtualScroll]="true"
                [style]="{ width: '100%' }"
                [maxSelectedLabels]="3"
                [defaultLabel]="groupsDefaultLabel"
                appendTo="body">
              </p-multiSelect>
            </div>
          }
        </div>
      </div>
    }
  </div>


  <ng-container footer>


    <button class="cancel-button" (click)="closeDialog()">
      <i class="fa fa-times"></i>
      <span i18n="@@cancelarBtn">
        Cancelar
      </span>
    </button>

    <!-- [disabled]="isCrosstableModified() || display_v.btnSave" -->

    <button class="confirm-button" [disabled]="!((selectedUsers.length !==0) || (selectedRoles.length !==0))" (click)="savePermission()">
      <i class="fa fa-check"></i>
      <span i18n="@@guardarBtn">
        Confirmar
      </span>
    </button>
  </ng-container>



</eda-dialog2>